const columns = [
    {
        field: "id",
        headerName: "Invoice #",
        description: "Invoice ID",
        maxWidth: 90,
        flex: 1,
    },
    {
        field: "createdAt",
        headerName: "Date",
        minWidth: 160,
        flex: 1.5,
        valueGetter: (createdAt) => {
            return new Date(createdAt).toLocaleString();
        },
    },
    {
        field: "priceFinal",
        headerName: "Total Amount",
        minWidth: 120,
        flex: 1,
        valueFormatter: (params) => {
            return typeof params === "number" ? params.toFixed(4) : params;
        },
    },
    {
        field: "paidAmount",
        headerName: "Paid Amount",
        minWidth: 120,
        flex: 1,
        valueFormatter: (params) => {
            return typeof params === "number"
                ? params.toFixed(4)
                : Number(params).toFixed(4);
        },
    },
    {
        field: "remainingAmount",
        headerName: "Remaining",
        minWidth: 120,
        flex: 1,
        cellClassName: (params) => {
            return Number(params.value) > 0 ? "remaining-amount-cell" : "";
        },
        valueFormatter: (params) => {
            return typeof params === "number" ? params.toFixed(4) : params;
        },
        renderCell: (params) => {
            console.log(params);
            const value = Number(params.row.remainingAmount);
            return (
                <span
                    style={{
                        fontWeight: "bold",
                        color: value > 0 ? "#d32f2f" : "#2e7d32",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        backgroundColor:
                            value > 0
                                ? "rgba(255, 235, 230, 0.4)"
                                : "transparent",
                    }}
                >
                    {value.toFixed(4)}
                </span>
            );
        },
    },
    {
        field: "status",
        headerName: "Status",
        minWidth: 120,
        flex: 1,
        renderCell: (params) => {
            const status =
                Number(params.row.remainingAmount) > 0 ? "Not Paid" : "Paid";
            const statusStyles = {
                Paid: { color: "#2e7d32", backgroundColor: "#e8f5e9" },
                Unpaid: { color: "#d32f2f", backgroundColor: "#ffebee" },
                PartiallyPaid: { color: "#f57c00", backgroundColor: "#fff3e0" },
            };
            return (
                <span
                    style={{
                        ...(statusStyles[status] || {}),
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontWeight: "bold",
                    }}
                >
                    {status}
                </span>
            );
        },
    },
    {
        field: "employee",
        headerName: "Sold By",
        minWidth: 120,
        flex: 1,
        valueGetter: (employee) => {
            return employee?.name || "";
        },
    },
];

const Get_Customer_Report_URI = (id) => `/invoices/customer/report/${id}`;

export { columns, Get_Customer_Report_URI };
